import type { SystemSubject, SystemAction } from '../types';

export const ALL_SUBJECTS: { key: SystemSubject; label: string }[] = [
	{ key: 'all', label: 'Todos' },
	{ key: 'dashboard', label: 'Dashboard' },
	{ key: 'users', label: 'Usuários' },
	{ key: 'farmers', label: 'Agricultores' },
	{ key: 'consultants', label: 'Consultores' },
	{ key: 'companies', label: 'Empresas' },
	{ key: 'props', label: 'Propriedades' },
	{ key: 'farmers-props', label: 'Prop. Agricultores' },
	{ key: 'products', label: 'Produtos' },
	{ key: 'samples', label: 'Análises' },
	{ key: 'farmers-samples', label: 'Análises Agricultores' },
	{ key: 'recommendations', label: 'Recomendações' },
	{ key: 'farmers-recommendations', label: 'Rec. Agricultores' },
	{ key: 'groups', label: 'Grupos' },
	{ key: 'hierarchies', label: 'Hierarquias' },
	{ key: 'plans', label: 'Planos' },
	{ key: 'payments', label: 'Pagamentos' },
	{ key: 'parcelling', label: 'Parcelamento' },
	{ key: 'testimonials', label: 'Depoimentos' },
	{ key: 'landingPlans', label: 'Planos Landing' },
];

export const ALL_FEATURES: { key: Extract<SystemSubject, 'agronomo-support' | 'technical-support'>; label: string }[] = [
	{ key: 'agronomo-support', label: 'Suporte Agronômico' },
	{ key: 'technical-support', label: 'Suporte Técnico' },
];

export const ALL_ACTIONS: { key: SystemAction; label: string }[] = [
	{ key: 'read', label: 'Ler' },
	{ key: 'create', label: 'Criar' },
	{ key: 'update', label: 'Editar' },
	{ key: 'delete', label: 'Excluir' },
];

export const PAYMENT_METHOD_OPTIONS = [
	{ value: 'boleto', label: 'Boleto' },
	{ value: 'credit_card', label: 'Cartão de Crédito' },
	{ value: 'pix', label: 'PIX' },
	{ value: 'free', label: 'Gratuito' },
];

export const RECURRING_OPTIONS = [
	{ value: 'yes', label: 'Sim' },
	{ value: 'no', label: 'Não' },
];

export const BOOL_OPTIONS = [
	{ value: 'yes', label: 'Sim' },
	{ value: 'no', label: 'Não' },
];

export const INTERVAL_OPTIONS = [
	{ value: 'day', label: 'Dia' },
	{ value: 'week', label: 'Semana' },
	{ value: 'month', label: 'Mês' },
	{ value: 'year', label: 'Ano' },
];

export const IS_LISTABLE_OPTIONS = [
	{ value: 'yes', label: 'Ativo' },
	{ value: 'no', label: 'Inativo' },
];

export const DEFAULT_GROUP_FORM: import('../types').GroupFormData = {
	name: '',
	permissions: [],
};

export const DEFAULT_HIERARCHY_FORM: import('../types').HierarchyFormData = {
	name: '',
	description: '',
	farmer: '',
	consultant: '',
	company: '',
	master: '',
};

export const DEFAULT_PLAN_FORM: import('../types').PlanFormData = {
	name: '',
	description: '',
	paymentMethods: [],
	hierarchy: '',
	isListable: '',
	price: '',
	recurrentPayment: '',
	interval: '',
	intervalCount: '',
	gracePeriod: '',
	notifyUnpayment: '',
	notifyInvoice: '',
	maxInstallments: '',
	maxProps: '',
	maxSamples: '',
	monthlyFloraTokens: '',
	paymentLink: '',
	advantages: [''],
};
